"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const BackTopSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 10.828L7.05023 15.778L5.63623 14.364L12.0002 8L18.3642 14.364L16.9502 15.778L12.0002 10.828Z" fill="currentColor"/>
</svg>

)

const BackTopIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BackTopSvg} {...props} />
);

export default BackTopIcon